import React from 'react';
import { Route } from 'react-router-dom';
import About from '../pages/about/About';
import ProtectedRoute from '../components/global/ProtectedRoute';

const aboutRoutes = (
    <Route
        path="/about"
        element={
            <ProtectedRoute requiredPermission="settings.about-us.view">
                <About />
            </ProtectedRoute>
        }
    />
);

export default aboutRoutes;
